module.exports = __webpack_public_path__ + "static/media/view6.ad8ea4b1.jpg";